module.exports = __webpack_public_path__ + "img/nemId.62068b49.svg";